import type {
  ReactElement,
} from 'react';

export function IndicatorSeparator(): ReactElement | null {
  return null;
}
